import Vue from 'vue'

const state = {
  documents: [],
  documentTypes: {},
  loading: false,
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 15,
    total: 0
  }
}

const getters = {
  getDocuments: state => state.documents,
  getDocumentTypes: state => state.documentTypes,
  getDocumentsLoading: state => state.loading,
  getDocumentsPagination: state => state.pagination
}

const actions = {
  documentsRequest: async ({ commit }, queries = {}) => {
    commit('SET_DOCUMENTS_LOADING', true)
    
    // Build query parameters
    const params = new URLSearchParams()
    
    if (queries.search) {
      params.append('search', queries.search)
    }
    if (queries.sort) {
      params.append('sort', queries.sort)
    }
    if (queries.direction) {
      params.append('direction', queries.direction)
    }
    if (queries.per_page) {
      params.append('per_page', queries.per_page)
    }
    if (queries.page) {
      params.append('page', queries.page)
    }

    return new Promise((resolve, reject) => {
      Vue.axios.get(`/api/documents?${params.toString()}`)
        .then(result => {
          commit('SET_DOCUMENTS', result.data.data)
          commit('SET_DOCUMENTS_PAGINATION', {
            current_page: result.data.current_page,
            last_page: result.data.last_page,
            per_page: result.data.per_page,
            total: result.data.total
          })
          resolve(result.data)
        })
        .catch(err => {
          if (err.response?.status === 403) {
            commit('setSnack', { 'type': 'error', 'msg': 'Accès non autorisé' })
          } else {
            commit('setSnack', { 'type': 'error', 'msg': 'Erreur lors du chargement des documents' })
          }
          reject(err)
        })
        .finally(() => {
          commit('SET_DOCUMENTS_LOADING', false)
        })
    })
  },

  documentTypesRequest: async ({ commit }) => {
    return new Promise((resolve, reject) => {
      Vue.axios.get('/api/documents/types')
        .then(result => {
          commit('SET_DOCUMENT_TYPES', result.data.types)
          resolve(result.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  documentDownloadRequest: async ({ commit }, documentId) => {
    return new Promise((resolve, reject) => {
      Vue.axios.get(`/api/documents/${documentId}/download`, {
        responseType: 'blob'
      })
        .then(result => {
          // Get content type to determine file extension
          const contentType = result.headers['content-type'] || result.data.type

          // Create download link with correct blob type
          const blob = new Blob([result.data], { type: contentType })
          const blobUrl = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = blobUrl

          // Get filename from response headers
          const contentDisposition = result.headers['content-disposition']
          let filename = null

          if (contentDisposition) {
            // Try filename*= (RFC 5987) first
            const filenameStarMatch = contentDisposition.match(/filename\*=(?:UTF-8'')?([^;\n]+)/i)
            if (filenameStarMatch && filenameStarMatch[1]) {
              filename = decodeURIComponent(filenameStarMatch[1].replace(/['"]/g, ''))
            } else {
              // Try filename= pattern
              const filenameMatch = contentDisposition.match(/filename=([^;\n]+)/i)
              if (filenameMatch && filenameMatch[1]) {
                filename = filenameMatch[1].replace(/['"]/g, '').trim()
              }
            }
          }

          // Fallback based on content type if filename not found
          if (!filename) {
            if (contentType && contentType.includes('zip')) {
              filename = 'document.zip'
            } else {
              filename = 'document.pdf'
            }
          }

          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(blobUrl)
          resolve(result.data)
        })
        .catch(err => {
          if (err.response?.status === 403) {
            commit('setSnack', { 'type': 'error', 'msg': 'Accès non autorisé' })
          } else if (err.response?.status === 404) {
            commit('setSnack', { 'type': 'error', 'msg': 'Document non trouvé' })
          } else {
            commit('setSnack', { 'type': 'error', 'msg': 'Erreur lors du téléchargement' })
          }
          reject(err)
        })
    })
  }
}

const mutations = {
  SET_DOCUMENTS: (state, documents) => {
    state.documents = documents
  },
  SET_DOCUMENT_TYPES: (state, types) => {
    state.documentTypes = types
  },
  SET_DOCUMENTS_LOADING: (state, loading) => {
    state.loading = loading
  },
  SET_DOCUMENTS_PAGINATION: (state, pagination) => {
    state.pagination = pagination
  }
}

export default {
  state,
  getters,
  actions,
  mutations
} 